/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estado inicial para un perfil nuevo
 */
export const INITIAL_PROFILE_STATE = {
  uuid: null,
  name: '',
  description: '',
  modules: [],
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  name: { width: '15%' },
  description: { width: '30%', minWidth: '300px' },
  actions: { width: '18%', textAlign: 'center' },
  access: { width: '12%', textAlign: 'center' },
};

/**
 * Mensajes de validación
 */
export const VALIDATION_MESSAGES = {
  NAME_REQUIRED: 'El nombre es requerido',
  NAME_MAX_LENGTH: 'El nombre no puede exceder los 50 caracteres',
  DESCRIPTION_MAX_LENGTH: 'La descripción no puede exceder los 255 caracteres',
};

/**
 * Títulos de diálogos
 */
export const DIALOG_TITLES = {
  ADD_PROFILE: 'Agregar Perfil',
  EDIT_PROFILE: 'Editar Perfil',
  ACCESS_PROFILE: 'Accesos para usuario',
};
